var scope_0 = require('/opt/build/repo/packages/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6097a4c3c8872cbe6111e45fb55c1935.js').default;

var scope_1 = require('/opt/build/repo/packages/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ad7f018c05df8a4c278e5ea2ede5199.js').default;

var scope_2 = require('/opt/build/repo/packages/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2);